import { render, staticRenderFns } from "./projectForm.vue?vue&type=template&id=2db30add&scoped=true&"
import script from "./projectForm.vue?vue&type=script&lang=js&"
export * from "./projectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db30add",
  null
  
)

export default component.exports